// extracted by mini-css-extract-plugin
export default {"container":"rules_container__tH5UW","btn":"rules_btn__bKjdH","list":"rules_list__JbZEp"};